import './answerpair.css';
import Timer from '../timer/timer';
import { config } from '../../config';

function AnswerPair({answered, situation, gameData}) {

  return (
    <>
    <Timer duration={gameData.config?.answer_duration || config.answerDuration} onDone={() => answered(3)} />
    <div className="answerpair-container" id='answerpair-card-id'>
      <AnswerCard
      logo={situation.option1Logo}
      subtitle={situation.option1Subtitle}
      content={situation.option1Title}
      onClick={() => answered(1)}
      position={"left"} />

      <AnswerCard
      logo={situation.option2Logo}
      subtitle={situation.option2Subtitle}
      content={situation.option2Title}
      onClick={() => answered(2)}
      position={"right"}/>
    </div>
    </>
  );
}

function AnswerCard({position, onClick, content, subtitle, logo}){

    const onSelected = () => {
        if(position === 'left'){
            document.getElementById('left-answer-card').classList.add('answer-choose-left');
            document.getElementById('right-answer-card').classList.add('unselected');
        }else{
            document.getElementById('left-answer-card').classList.add('unselected');
            document.getElementById('right-answer-card').classList.add('answer-choose-right');
        }

        onClick();
    } 

    return(
        <div onClick={() => onSelected()} className={'answer-card ' + position+"-tilt"} id={position+"-answer-card"}>
          <img  src={logo} alt="" className="logo"/>
            <b>{content}</b><br />
            {subtitle}
            <br />
            <span style={{color: "grey"}}>Tap to select</span>
        </div>
    );
}

export default AnswerPair;
